import { render, staticRenderFns } from "./AwardsBlock.vue?vue&type=template&id=fba83a5c&scoped=true&"
import script from "./AwardsBlock.vue?vue&type=script&lang=js&"
export * from "./AwardsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba83a5c",
  null
  
)

export default component.exports